import { Outlet } from "react-router-dom";
import { styles } from "../../shared-styles/styles";
import { Footer } from "../../components";

const RootLayout = () => {
  return (
    <div className="flex flex-col flex-1 min-h-0">
      <section className={styles.pageContentWrapper}>
        <Outlet />
      </section>
      <Footer />
    </div>
  );
};

export default RootLayout;
